import { IntegrityMonitorCustomRuleMainFormWebComponent } from './component/IntegrityMonitorCustomRuleMainFormWebComponent';
import { WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_MAIN_FORM } from '../../../../webcomponents.constants';

export { IntegrityMonitorCustomRuleMainFormWebComponent };

window.customElements.define(
  WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_MAIN_FORM,
  IntegrityMonitorCustomRuleMainFormWebComponent
);
